import React from 'react';
import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import SegmentBar from './SegmentBar';

// Tinted panel behind a journey's cards: a colored header tab (name) + the entry
// segment as criteria chips. Positioned by the canvas; cards render on top.
// The pencil opens the journey editor drawer, which owns the Delete affordance.
export default function JourneyPanel({ journey, x, top, height, hue = 0, attributeById, productById, onEditJourney = () => {}, dimmed = false, selected = false, selHue, selGlow, innerRef }) {
  const style = { left: x, top, height };
  if (selected) { style['--sel-hue'] = selHue; style['--sel-glow'] = selGlow; }
  return (
    <div ref={innerRef} className={`tl-panel tl-hue-${hue}${dimmed ? ' dimmed' : ''}${selected ? ' selected' : ''}`} style={style}>
      <div className="tl-panel-head">
        <div className="tl-panel-titles">
          <div className="tl-panel-eyebrow">Journey</div>
          <div className="tl-panel-name">{journey.name}</div>
        </div>
        <Tooltip title="Edit journey">
          <EditOutlined aria-label="edit journey" className="tl-panel-edit" onClick={() => onEditJourney(journey)} />
        </Tooltip>
      </div>
      <SegmentBar segment={journey.segment} attributeById={attributeById} productById={productById} showEmpty />
    </div>
  );
}
